// Innovation.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomButton from './CustomButton';
import berryClub from '../images/theBerryClub.png';
import bookberryClub from '../images/bookberryClub.png';

const images = { berryClub, bookberryClub };

const Innovation = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#ffffff' }}>
      <div className="max-w-7xl mx-auto px-4 py-32">
        <h1 className="text-4xl md:text-5xl font-bold text-[#00385c] text-center mb-16">
          Innovation by Novecta
        </h1>

        {/* Berry Club Section */}
        <div className="mb-20 bg-[#e0dcdc] rounded-tr-[40px] rounded-bl-[40px] shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-2 gap-8 p-8">
            <div className="flex flex-col justify-center">
              <h2 className="text-3xl font-bold text-[#003B5C] mb-4">The Berry Club</h2>
              <p className="text-gray-700 mb-6">
                Welcome to a world of possibilities with The Berry Club. Where connections, rewards, and experiences come together to make every moment extraordinary.
              </p>
              <div>
                <CustomButton 
                  onClick={() => window.open('https://berryclub.in', '_blank')}
                  className="px-8 py-2 bg-white text-black font-medium rounded-full border-2 border-[#8b123b] hover:bg-[#8b123b] hover:text-white transition-all"
                >
                  Visit Berry Club
                </CustomButton>
              </div>
            </div>
            <div className="flex items-center justify-center">
              <img 
                src={images.berryClub} 
                alt="Berry Club Logo" 
                className="rounded-tr-[40px] rounded-bl-[40px] shadow-md w-full max-w-md"
              />
            </div>
          </div>
        </div>

        {/* BookBerry Section */}
        <div className="bg-[#e0dcdc] rounded-tr-[40px] rounded-bl-[40px] shadow-lg overflow-hidden">
          <div className="grid md:grid-cols-2 gap-8 p-8">
            <div className="order-2 md:order-1 flex items-center justify-center">
              <img 
                src={images.bookberryClub} 
                alt="BookBerry Logo" 
                className="rounded-tr-[40px] rounded-bl-[40px] shadow-md w-full max-w-md"
              />
            </div>
            <div className="order-1 md:order-2 flex flex-col justify-center">
              <h2 className="text-3xl font-bold text-[#003B5C] mb-4">BookBerry Club</h2>
              <p className="text-gray-700 mb-6">
                Discover the joy of reading with Bookberry—where connections deepen, habits flourish, and loyalty thrives, one story at a time.
              </p>
              <div>
                <CustomButton 
                  onClick={() => window.open('https://bookberry.in', '_blank')}
                  className="px-8 py-2 bg-white text-black font-medium rounded-full border-2 border-[#8b123b] hover:bg-[#8b123b] hover:text-white transition-all"
                >
                  Visit BookBerry
                </CustomButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Innovation;